import { States } from '../../app.router';

/* @ngInject */
export default class ProjectsController {
    //  Project logic is moved into 'projects-modal'
    constructor(ProjectManager, $state) {
        this.ProjectManager = ProjectManager;
        this.$state = $state;
    }

    $onInit() {
        // This page should only be served if no project is selected
        const currentProject = this.ProjectManager.currentProject.id;
        if (currentProject) {
            this.$state.go(States.SENSORS, {
                projectId: currentProject
            })
        }
    }
}
